import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface IFilterState {
    value: IFilterType;
}

interface IFilterType {
    filteredData?: any;
}

const initialState: IFilterState = {
    value: {
        filteredData: [],
    },
};
export const slice = createSlice({
    name: 'filterUsers',
    initialState: { ...initialState },
    reducers: {
        openFilterUserAction: (state, action: PayloadAction<IFilterType>) => {
            state.value.filteredData =
                action.payload && action.payload.filteredData;
        },
    },
});
export const { openFilterUserAction } = slice.actions;
export const selectFilteredUserData = (state: RootState) =>
    state.filterUsers.value?.filteredData;
export const FilterUserReducer = slice.reducer;
